import { useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Gauge, Phone, Menu, X } from "lucide-react";

const links = [
  { label: "Accueil", href: "#accueil", id: "accueil" },
  { label: "Services", href: "#services", id: "services" },
  { label: "Tarifs", href: "/tarifs", id: "tarifs", page: true },
  { label: "À propos", href: "#apropos", id: "apropos" },
  { label: "Contact", href: "#contact", id: "contact" },
  { label: "Devis en ligne", href: "/configurateur", id: "devis", page: true },
  { label: "Réserver", href: "/reservation", id: "reservation", page: true },
];

export const Logo = () => {
  const { pathname } = useLocation();
  return (
    <a href={pathname === "/" ? "#accueil" : "/#accueil"} className="flex items-center gap-2" data-testid="navbar-logo">
      <span className="relative flex items-center justify-center w-9 h-9 border border-[#6EB000]/60 rounded-full">
        <Gauge className="w-5 h-5 text-[#6EB000]" strokeWidth={2.2} />
      </span>
      <span className="font-display text-2xl leading-none">
        <span className="text-white">NB</span>
        <span className="text-[#6EB000]">Perf</span>
      </span>
    </a>
  );
};

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const base = pathname === "/" ? "" : "/";

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#272B2E]/80 border-b border-white/10" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8" data-testid="navbar-links">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.page ? l.href : `${base}${l.href}`}
              data-testid={`nav-link-${l.id}`}
              className="text-sm uppercase tracking-widest text-white/70 hover:text-[#6EB000] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:block">
          <a
            href="tel:+33781901248"
            data-testid="nav-phone-button"
            className="clip-angle inline-flex items-center gap-2 bg-[#6EB000] text-black font-bold text-sm px-5 py-2.5 hover:bg-[#5A9000] active:scale-95 transition-all duration-200"
          >
            <Phone className="w-4 h-4" />
            07 81 90 12 48
          </a>
        </div>
        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden border-t border-white/10 bg-[#272B2E]"
            data-testid="nav-mobile-menu"
          >
            <div className="px-5 py-4 flex flex-col gap-4">
              {links.map((l) => (
                <a
                  key={l.id}
                  href={`${base}${l.href}`}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${l.id}`}
                  className="text-sm uppercase tracking-widest text-white/80 hover:text-[#6EB000]"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="tel:+33781901248"
                data-testid="nav-mobile-phone-button"
                className="inline-flex items-center gap-2 text-[#6EB000] font-bold"
              >
                <Phone className="w-4 h-4" /> 07 81 90 12 48
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
